module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1520-d54840357ef81c5af1d7d24c237e9ab6.png";